import { Flex, Image, Space, Stack } from '@mantine/core';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { LBClubCard } from '@/features/search/components/club-card';
import { NotFoundResults } from '@/features/search/components/not-found-results/NotFoundResults';
import { PageLoading } from '@/pages/PageLoading';
// import { COUNTRY_LIST } from '@/shared/data/country';
import { LBSearchMultiselect } from '@/shared/ui-kit/components';

import { useArtistSearchPage } from './hooks/useArtistSearchPage';

import logo from '@/../public/logo.svg';

export const ArtistSearchPage = () => {
  const {
    data,
    state,
    functions: { navigate }
  } = useArtistSearchPage();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const savedScroll = sessionStorage.getItem('searchScrollY');
    const savedClubId = sessionStorage.getItem('searchClubId');

    if (savedScroll) {
      setTimeout(() => {
        window.scrollTo({ top: parseInt(savedScroll, 10), behavior: 'auto' });
        sessionStorage.removeItem('searchScrollY');
      }, 100);
    }

    if (savedClubId) {
      setTimeout(() => {
        const element = document.querySelector(
          `[data-club-id="${savedClubId}"]`
        );
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        sessionStorage.removeItem('searchClubId');
      }, 200);
    }
  }, []);

  if (state.isLoading) return <PageLoading />;

  return (
    <div>
      <Flex align='end' justify='space-between'>
        <Image alt='Logo' src={logo} />
      </Flex>

      <Space h={16} />

      <LBSearchMultiselect
        searchable
        placeholder={formatMessage({ id: 'form.search.placeholder' })}
        value={state.country ?? []}
        data={state.availableCountries.map((country) => ({
          label: country,
          value: country
        }))}
        onChange={state.setCountries}
      />

      <Stack gap={20} mt={20}>
        {data.length > 0 ? (
          data.map((item) => (
            <LBClubCard
              key={item.clubProfileId}
              data={item}
              data-club-id={item.clubProfileId}
              navigate={() => {
                sessionStorage.setItem(
                  'searchScrollY',
                  window.scrollY.toString()
                );
                sessionStorage.setItem(
                  'searchClubId',
                  item.clubProfileId.toString()
                );
                navigate({
                  to: '/artist/$id/profile-info/$clubId',
                  params: { clubId: item.clubProfileId.toString() }
                });
              }}
            />
          ))
        ) : (
          <NotFoundResults />
        )}
      </Stack>
      <div ref={state.elementRef} />
    </div>
  );
};
